module.exports = __webpack_public_path__ + "img/3-Archive-94-min.cbd431e2.jpg";